"use client";

import { useState } from "react";
import { createPortal } from "react-dom";
import { ButtonLink } from "@/components/ui/Button";
import { LogoutButton } from "@/components/layout/LogoutButton";

export function PlazaAccountPrompt({ returnTo, registrationPending = false, autoOpen = false, guest = false, canSwitchIdentity = false, workbenchHref = "/partner" }: { returnTo: string; registrationPending?: boolean; autoOpen?: boolean; guest?: boolean; canSwitchIdentity?: boolean; workbenchHref?: string }) {
  const loginHref = `/login?${new URLSearchParams({ next: returnTo })}`;
  const [open, setOpen] = useState(autoOpen);
  return <>
    <button type="button" onClick={() => setOpen(true)}>申请授权</button>
    {open && createPortal(<dialog
      ref={element => { if (element && !element.open) element.showModal(); }}
      onClose={() => setOpen(false)}
      aria-labelledby="plaza-account-prompt-title"
      className="fixed inset-0 m-auto w-[420px] max-w-[94vw] rounded-2xl border border-[var(--color-line)] bg-[var(--color-surface)] p-6 text-center text-[var(--color-paper)] shadow-xl backdrop:bg-black/60"
    >
      <h2 id="plaza-account-prompt-title" className="text-xl font-semibold">{registrationPending ? "请先完成企业入驻" : "请使用企业账号申请"}</h2>
      {!registrationPending && canSwitchIdentity && <p className="mt-3 text-sm text-[var(--color-muted)]">你的账号支持多身份，可在控制台右上角切换为电商或导演。</p>}
      <div className="mt-5 flex flex-wrap items-center justify-center gap-3">
        {canSwitchIdentity && <ButtonLink href={workbenchHref}>切换身份</ButtonLink>}
        {registrationPending && <ButtonLink href="/onboarding">继续入驻</ButtonLink>}
        {guest ? <ButtonLink href={loginHref}>登录</ButtonLink> : <LogoutButton redirectTo={loginHref} className="btn-glass inline-flex items-center justify-center rounded-[var(--radius-pill)] px-5 py-2.5 text-sm font-medium whitespace-nowrap disabled:opacity-50">切换账号</LogoutButton>}
        <button type="button" className="text-sm text-[var(--color-muted)]" onClick={() => setOpen(false)}>取消</button>
      </div>
    </dialog>, document.body)}
  </>;
}
